<template>
  <div id="its-client">
    <slot name="topbar" />

    <v-main>
      <v-container
        class="fill-height pa-0 ma-0"
        fluid
      >
        <slot name="main" />
      </v-container>
    </v-main>

    <slot name="footer" />
    <Modal :show="showModal"/>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, Ref } from 'vue';
import useHandleDrawer from '@/components/composers/useHandleDrawer';
import Modal          from '@/components/modals/Modal.vue';
import store from '@/store';

const AppMainLayout: object = defineComponent({
  name: 'AppMainLayout',
  components: {
    Modal,
  },
  setup() {
    const showModal: Ref<boolean> = computed(() => store.state.modal.display);
    return {
      showModal,
      ...useHandleDrawer(),
    };
  },
});
export default AppMainLayout;
</script>

<style scoped lang="scss">
#its-client {
  height: 100%;
}

.v-main {
  height: 100%;
}
</style>
